import React from 'react';
import { Button, ButtonProps } from 'semantic-ui-react';
import config from '@config/config';
import { styled } from '@modules/common/components/ThemeProvider/utils';

const TertiaryButtonBase = (props: ButtonProps) => {
  return (
    <Button
      type="button"
      {...props}
      style={{
        ...props.style,
        color: config.darkBackgroundColor,
        textDecoration: 'underline',
        backgroundColor: 'transparent',
        border: 'none',
        fontWeight: 'normal',
        padding: 0,
        whiteSpace: 'nowrap',
      }}
    />
  );
};

const TertiaryButton = styled(TertiaryButtonBase)`
  .icon {
    text-decoration: none;
  }

  color: ${config.darkBackgroundColor} !important;
  text-decoration: underline;
`;

export default TertiaryButton;
